$j(document).ready(function () {
    interimMessages().initInterimMessageDialogs();

    var jsRedirectClick = function (event, element) {
        event.preventDefault();
        var $dataLink = element.attr("data-link"),
            $targetUrl = element.attr("href"),
            timeout = 0;
        if ($j('#navigation').hasClass('pageslide')) {
            closePageSlide();
            timeout = 400;
        }
        setTimeout(function () {
            interimMessages().showInterimMessage({ url: $targetUrl, dialogName: $dataLink });
        }, timeout);
    }

    if (jQuery && jQuery.fn.on) {
        jQuery(document).on("click", 'a.js-redirect', function (e) {
            jsRedirectClick(e, $j(this));
        });
    } else {
        jQuery('a.js-redirect').bind("click", function (e) {
            jsRedirectClick(e, $j(this));
        });
    }
});

var interimMessages = function () {

    var aaUtil = new aa_Utilities(),
        _goBackFrench = "Retour",
        _continueFrench = "Continuer";


    var initInterimMessageDialog = function (dialogName) {

        var btnArray = [];
        btnArray[0] = {
            name: _continueFrench,
            cssClass: "btn",
            id: dialogName,
            callback: function () {
                var $targetUrl = $j("#" + dialogName + "Dialog").attr("data-href");
                window.open($targetUrl, "_blank");
            }
        };
        btnArray[1] = {
            name: _goBackFrench,
            cssClass: "btn btn-secondary",
            closeDialog: true
        };

        aaUtil.aaDialog(dialogName, {
            autoOpen: false,
            width: 'small',
            buttons: btnArray,
            toggleScroll: true,
            showFullScreen: true
        });
    };

    var initInterimMessageDialogs = function () {
        var dialogNames = ["aavInterimMessage", "cruisesInterimMessage", "refundsInterimMessage", "bgsInterimMessage"];

        $j.each(dialogNames, function (i, dialogName) {
            initInterimMessageDialog(dialogName);
            $j("#" + dialogName + "Dialog").removeClass("is-hidden");
        });
    };

    var showInterimMessage = function (metadata) {
        var $url = metadata.url;
        var $dialog = '#' + metadata.dialogName + 'Dialog';

        $j($dialog).attr('data-href', $url);
        aaUtil.aaDialog($dialog).openDialog();
    };

    return {
        showInterimMessage: showInterimMessage,
        initInterimMessageDialogs: initInterimMessageDialogs
    }
};

